export const pageview = (url, measurementId) => {
  if (!measurementId || typeof window === "undefined" || !window.gtag) return;

  window.gtag("config", measurementId, {
    page_path: url,
  });
};

// Gửi sự kiện tùy chỉnh (nếu cần)
export const event = ({ action, category, label, value }) => {
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
